'use client';

import { FC } from 'react';
import TopSellingCard from '@/components/Cards/TopSellingCard';
import { ResponsiveCarousel } from '@base/components/src/Carousel';
import { TopSellingProduct } from '@/types/algonomy';

import { SearchEmptyProps } from './types';
import styles from './SearchEmptyCarousel.module.css';

const SearchEmptyCarousel: FC<SearchEmptyProps> = ({ topSellingProducts, mobile }) => {
  return (
    <ResponsiveCarousel<TopSellingProduct>
      visibleSlidesQuery={{
        xxl: 5,
        xl: 4,
        lg: 3,
        md: 3,
        sm: 2,
        xs: 2,
      }}
      hideArrow
      slideData={topSellingProducts}
      carouselPadding={'!h-[280px] !pb-0 sm:!h-[340px]'}
      carouselHeight={'!h-[280px] sm:!h-[340px]'}
      className={styles.emptyCarousel}
      dotClassName={styles.dots}
      slideContentClassName={styles.slideContent}
      renderSlide={(searchItem: TopSellingProduct, idx: number) => <TopSellingCard searchItem={searchItem} idx={idx} />}
      dragStep={mobile ? 2 : 5}
    />
  );
};

export default SearchEmptyCarousel;
